import React, { useState } from 'react'
import { Classes } from '@blueprintjs/core'
import { Dialog } from '@ui'
import { IconButton } from '@ui'
import EmployeeForm from './EmployeeForm'
import { navigateWithBasepath as navigate } from '../../App'

interface NewEmployeeDialogProps {
  isOpen: boolean
  onClose: () => void
  reload: () => void
}

const NewEmployeeDialog: React.FunctionComponent<NewEmployeeDialogProps> = ({
  isOpen,
  onClose,
  reload,
}: NewEmployeeDialogProps) => {
  const [dirty, setDirty] = useState(false)
  const employee = {
    name: '',
    email: '',
    phone: '',
    title: '',
    employmentType: '',
    badge: '',
    note: '',
    geoLocation: null,
    department: null,
    manager: null,
    startDate: null,
    endDate: null,
  }

  return (
    <Dialog
      isOpen={isOpen}
      style={{ width: 900 }}
      canEscapeKeyClose={false}
      canOutsideClickClose={!dirty}
      isCloseButtonShown={false}
      transitionDuration={200}
      title="New Employee"
      usePortal
      onClose={onClose}
      toolbar={
        <div className="dialog-buttons">
          {!dirty && <IconButton minimal tooltip="Close" iconName="times" onClick={onClose} />}
        </div>
      }
      body={
        <div className={Classes.DIALOG_BODY}>
          <EmployeeForm
            dirty={dirty}
            setDirty={setDirty}
            employee={employee}
            onCancel={() => {
              setDirty(false)
              onClose()
            }}
            onSubmit={(employee) => {
              onClose()
              setDirty(false)
              reload()
              navigate(`?employeeId=${employee.id}`, {})
            }}
          />
        </div>
      }
    />
  )
}

export default NewEmployeeDialog
